import KineticHero from "@/components/site/KineticHero";
import FactBar from "@/components/site/FactBar";
import ManifestoChapters from "@/components/site/ManifestoChapters";
import BuyerSwitcher from "@/components/site/BuyerSwitcher";
import EconomicsSection from "@/components/site/EconomicsSection";
import PathwayTimeline from "@/components/site/PathwayTimeline";
import AfricaMap from "@/components/site/AfricaMap";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import FinalCTA from "@/components/site/FinalCTA";

export default function Home() {
  return (
    <>
      <KineticHero />
      <FactBar variant="light" />
      <ManifestoChapters />
      <BuyerSwitcher />
      <EconomicsSection />
      <PathwayTimeline />
      <AfricaMap />
      <EditorialMarquee />
      <FinalCTA
        eyebrow="Let's begin"
        title={
          <>
            Let's talk about
            <br />
            <span className="font-display-italic text-[#f26522]">your market.</span>
          </>
        }
      />
    </>
  );
}
